import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=364fe787&scoped=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"
import style0 from "./Item.vue?vue&type=style&index=0&id=364fe787&prod&lang=scss&scoped=true"
import style1 from "./Item.vue?vue&type=style&index=1&id=364fe787&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364fe787",
  null
  
)

export default component.exports